/** Slots de impresora térmica: cocina y caja (sin barra). */
export const PRINTER_SLOT_LABELS = {
  kitchen: 'Cocina / Comanda',
  cashier: 'Caja (cuenta)',
};

const STORAGE_KEY = 'pizas:thermal-printers:v1';

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

function writeAll(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function getPairedPrinter(slot) {
  return readAll()[slot] || null;
}

export function savePairedPrinter(slot, device, channel) {
  const prev = readAll()[slot];
  const entry = {
    slot,
    deviceId: device.id,
    deviceName: device.name || prev?.deviceName || 'Impresora',
    pairedAt: Date.now(),
    serviceUuid: channel?.serviceUuid ?? prev?.serviceUuid,
    characteristicUuid: channel?.characteristicUuid ?? prev?.characteristicUuid,
  };
  const all = readAll();
  all[slot] = entry;
  writeAll(all);
  return entry;
}

export function clearPairedPrinter(slot) {
  const all = readAll();
  delete all[slot];
  writeAll(all);
}

export function resolveKitchenPrintSlot(activeSlot) {
  const kitchen = getPairedPrinter('kitchen');
  const cashier = getPairedPrinter('cashier');
  if (!kitchen && !cashier) return null;
  if (activeSlot && getPairedPrinter(activeSlot)) return activeSlot;
  if (kitchen) return 'kitchen';
  return 'cashier';
}
